import { jsxs as x, jsx as o } from "react/jsx-runtime";
import C, { useState as u, useCallback as p } from "react";
import { Root as g, Indicator as S } from "../../node_modules/@radix-ui/react-checkbox/dist/index.es.js";
import v from "../text/Text.es.js";
import { getStyleProps as j } from "../utils.es.js";
import B from "../../icons/FormCheckbox.es.js";
import { containerStyles as I, checkBoxStyles as R, labelStyles as _ } from "./Checkbox.styles.es.js";
const $ = {
  root: I,
  checkbox: R,
  label: _
}, z = (h) => {
  const [e, m] = j(h, $, "checkbox"), {
    defaultChecked: l,
    onChange: c,
    label: a,
    children: r,
    checked: i,
    value: t,
    ref: s,
    ...n
  } = m, [b, k] = u(l), f = p((d) => {
    k(d), c == null || c(d, t);
  }, [c, t]);
  return /* @__PURE__ */ x("div", { ...e == null ? void 0 : e.root(), children: [
    /* @__PURE__ */ o(g, { ref: s, checked: i === void 0 ? b : i, defaultChecked: l, id: t, value: t, onCheckedChange: f, ...e == null ? void 0 : e.checkbox(), ...n, children: /* @__PURE__ */ o(S, { children: /* @__PURE__ */ o(B, {}) }) }),
    /* @__PURE__ */ o(v, { asChild: !r, fontSize: "large", fontWeight: "$regular", ...r && {
      "aria-label": a
    }, ...e == null ? void 0 : e.label({
      disabled: n.disabled
    }), children: r || /* @__PURE__ */ o("label", { children: a }) })
  ] });
}, D = C.memo(z);
export {
  $ as checkBoxClasses,
  D as default
};
//# sourceMappingURL=Checkbox.es.js.map
